import { SubTypeDisplayPipe } from "./../../../../shared/pipes/sub-type-display.pipe";
import {
  Component,
  OnInit,
} from "@angular/core";
import { NgbDatepickerI18n, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { AlertService } from "src/app/services/alert.service";
import {
  DatePickerTrLangService,
  I18n,
} from "src/app/services/date-picker-tr-lang.service";
import { ExchangeService } from "src/app/services/exchange.service";
import { UnknownCostResponseItem } from "src/app/models/exchange/unknown-cost-response-item";
import { BaseListResponse } from "src/app/core/models/responses/base-list-response";
import { SetUnknownCostRequest } from "src/app/models/exchange/set-unknown-cost-request";
import { Currency, ExchangeCurrencyList } from "src/app/models/enums/currency";
import { CurrencySubTypes } from "src/app/models/enums/currency-sub-types";
import { CustomCurrencyPipe } from "src/app/shared/pipes/custom-currency.pipe";
import { ExchangeItem } from "src/app/models/exchange/exchange-item-request";
import { BaseListComponent } from "src/app/shared/components/base-list/base-list.component";
import { BasePagingRequest } from "src/app/core/models/requests/base-paging-request";
import { ExchangeFilter } from "src/app/models/filters/exchange-filter";
import { ExchangeCost } from "src/app/models/exchange/exchange-cost";
import { BasePagingResponse } from "src/app/core/models/responses/base-paging-response";
import { getCurrencySubTypeItem } from "src/app/core/helpers/common-functions";
import { ExchangeRecalculationResult } from "src/app/models/exchange/exchange-recalculation-result";
import { ExchangeOpeningBalance } from "src/app/models/exchange/exchange-opening-balance";

@Component({
  selector: "app-unit-costs",
  templateUrl: "./unit-costs.component.html",
  styleUrls: ["./unit-costs.component.scss"],
  providers: [
    I18n,
    { provide: NgbDatepickerI18n, useClass: DatePickerTrLangService },
    CustomCurrencyPipe,
    SubTypeDisplayPipe,
  ],
})
export class UnitCostsComponent
  extends BaseListComponent
  implements OnInit
{
  model: BaseListResponse<UnknownCostResponseItem>;
  request: SetUnknownCostRequest[];
  clicked: boolean = false;
  Currency = Currency;
  CurrencySubTypes = CurrencySubTypes;
  item: SetUnknownCostRequest;
  selectedIndex: number = 0;
  HAS_PLACEHOLDER = "/HAS Alış Maliyeti";
  costHASPlaceHolder = "";
  beginDateModel: NgbDateStruct;
  endDateModel: NgbDateStruct;
  defaultValue = null;
  currencyList = ExchangeCurrencyList;
  paymentSubTypes;
  listRequest: BasePagingRequest<ExchangeFilter> = {
    pageIndex: this.pageIndex,
    itemPerPage: this.itemPerPage,
    filter: {
      exchangeCurrency: null,
      exchangeSubType: null,
      paymentCurrency: null,
      paymentSubType: null,
    },
  };
  listResponse: BasePagingResponse<ExchangeCost>;
  costs: ExchangeItem[];
  recalculating = false;

  /** Açılış stokları ve giriş formu. Açılış, alım/satım dışından gelen stoğu deftere tanıtır. */
  openings: ExchangeOpeningBalance[] = [];
  opening: ExchangeOpeningBalance = this.emptyOpening();
  openingSubTypes;
  openingDateModel: NgbDateStruct;
  savingOpening = false;
  constructor(
    private service: ExchangeService,
    private alertService: AlertService,
    private customCurrencyPipe: CustomCurrencyPipe,
    private subTypePipe: SubTypeDisplayPipe,
  ) {
    super();
  }

  ngOnInit() {
    this.service.refreshIndex.subscribe((res) => {
      this.reloadUnkwnownCostsData();
      this.reloadCosts();
    });
    this.reloadUnkwnownCostsData();
    this.reloadCosts();
    this.reloadOpenings();
  }

  private emptyOpening(): ExchangeOpeningBalance {
    return { currency: null, subType: null, amount: null, unitCostHAS: null };
  }

  reloadOpenings() {
    this.service.getOpeningBalances().toPromise().then(res => {
      this.openings = res?.data ?? [];
    });
  }

  openingCurrencyChanged() {
    const item = getCurrencySubTypeItem(this.opening.currency);
    this.openingSubTypes = item.subtypes;
    this.opening.subType = null;
    // Has altının has maliyeti tanım gereği 1.
    if (this.opening.currency == Currency.Gold) this.opening.unitCostHAS = null;
  }

  /**
   * Açılış stoğunu kaydeder. Kaydettikten sonra o birimin geçmişi sunucuda yeniden hesaplanır,
   * bu yüzden maliyet listesi de tazelenir.
   */
  saveOpening() {
    if (!this.opening.currency || !this.opening.amount || !this.opening.unitCostHAS) {
      this.alertService.showErrorToast("Birim, miktar ve has maliyeti zorunlu.");
      return;
    }

    if (this.openingDateModel) {
      const d = this.openingDateModel;
      this.opening.date = new Date(d.year, d.month - 1, d.day);
    }

    this.savingOpening = true;
    this.service.saveOpeningBalance(this.opening).toPromise().then(res => {
      this.savingOpening = false;
      if (res?.isSuccess) {
        this.opening = this.emptyOpening();
        this.openingSubTypes = null;
        this.openingDateModel = null;
        this.alertService.showSuccessToast();
        this.service.refreshIndex.next();
        this.reloadOpenings();
      }
    }).catch(() => this.savingOpening = false);
  }

  deleteOpening(item: ExchangeOpeningBalance) {
    this.alertService.showConfirmAlert(
      "Açılış stoğu silinecek ve bu birimin geçmişi yeniden hesaplanacak. Devam edilsin mi?"
    ).then(res => {
      if (!res.isConfirmed) return;
      this.service.deleteOpeningBalance(item.id).toPromise().then(() => {
        this.alertService.showSuccessToast();
        this.service.refreshIndex.next();
        this.reloadOpenings();
      });
    });
  }

  reloadUnkwnownCostsData() {
    this.service
      .getUnknownCosts()
      .toPromise()
      .then((res) => {
        this.model = res;
        this.request = [];
        res.data.map((p) => {
          this.request.push({
            paymentCurrency: p.paymentCurrency,
            paymentSubType: p.paymentSubType,
            totalPaymentAmount: p.totalPaymentAmount,
          });
        });
        this.getCostItem(this.selectedIndex);
      });
  }

  reloadCosts() {
    this.Loading = true;
    this.setDates();
    this.service
      .getAllCosts(this.listRequest)
      .toPromise()
      .then((res) => {
        this.Loading = false;
        this.listResponse = res;
      });
  }

  setDates() {
    if (this.beginDateModel) {
      this.listRequest.filter.beginDate = new Date();
      this.listRequest.filter.beginDate.setFullYear(
        this.beginDateModel.year,
        this.beginDateModel.month - 1,
        this.beginDateModel.day,
      );
      this.listRequest.filter.beginDate.setHours(0,0,0);
    }

    if (this.endDateModel) {
      this.listRequest.filter.endDate = new Date();
      this.listRequest.filter.endDate.setFullYear(
        this.endDateModel.year,
        this.endDateModel.month - 1,
        this.endDateModel.day
      );
      this.listRequest.filter.beginDate.setHours(23,59,59);

    }
  }

  /** Kayıt defteri has altın; yalnızca has maliyeti giriliyor. */
  validate(item: SetUnknownCostRequest): boolean {
    return !!item.costHAS;
  }

  paymentCurrencyChanged() {
    let item = getCurrencySubTypeItem(this.listRequest.filter.paymentCurrency);
    this.paymentSubTypes = item.subtypes;
    this.listRequest.filter.paymentSubType = null;
    this.reloadCosts();
  }

  getCostItem(index) {
    this.item = this.request[this.selectedIndex];
    let payment = this.customCurrencyPipe.transform(this.item.paymentCurrency);
    if (this.item.paymentSubType)
      payment = this.subTypePipe.transform(this.item.paymentSubType);

    this.costHASPlaceHolder = payment + this.HAS_PLACEHOLDER;

    if (
      this.item.paymentCurrency == Currency.Gold &&
      this.item.paymentSubType == CurrencySubTypes.Has
    )
      this.item.costHAS = 1;
  }

  save(item: SetUnknownCostRequest) {
    if (this.validate(item)) {
      this.clicked = true;
      this.service
        .setUnknownCosts(item)
        .toPromise()
        .then((res) => {
          this.clicked = false;
          if (res.isSuccess) {
            this.service.refreshIndex.next();
            this.alertService.showSuccessToast();
          }
        });
    } else
      this.alertService.showErrorToast("Lütfen has maliyetini girin!");
  }

  delete(item: SetUnknownCostRequest) {
    this.alertService.showConfirmAlert("Seçtiğiniz birime ait maliyetlerin tümü silinecek. Devam etmek istiyor musunuz?").then(res => {
      if (res.isConfirmed) {
        this.service.deleteCosts(item).toPromise().then(res => {
          this.service.refreshIndex.next();
          this.alertService.showSuccessToast();
        })
      }
    })
  }

  update(item: SetUnknownCostRequest) {}

  /** Detay sayfası birimi ve ekrandaki tarih filtresini sorgu parametresiyle alır. */
  detailQueryParams(cost: ExchangeCost) {
    const params: any = { currency: cost.currency };
    if (cost.subType !== null && cost.subType !== undefined) params.subType = cost.subType;
    if (this.beginDateModel) params.beginDate = this.toQueryDate(this.beginDateModel);
    if (this.endDateModel) params.endDate = this.toQueryDate(this.endDateModel);
    return params;
  }

  private toQueryDate(model: NgbDateStruct): string {
    const pad = (value: number) => (value < 10 ? "0" + value : "" + value);
    return `${model.year}-${pad(model.month)}-${pad(model.day)}`;
  }

  /**
   * Maliyetleri baştan hesaplar: önce yazmadan etkisini gösterir, onaylanırsa uygular
   * (alim-satim-maliyet.md). Uygulamak yalnızca yöneticiye açık; sunucu da denetliyor.
   */
  async recalculate() {
    this.recalculating = true;
    try {
      const preview = (await this.service.recalculateCosts(true).toPromise())?.data;
      if (!preview) return;

      if (preview.changedRows === 0) {
        this.alertService.showSuccessToast("Maliyetler güncel, değişecek işlem yok.");
        return;
      }

      const confirmed = await this.alertService.showConfirmAlert(
        this.recalculationSummary(preview), "Uygula", "Vazgeç", true);
      if (!confirmed.isConfirmed) return;

      const result = (await this.service.recalculateCosts(false).toPromise())?.data;
      if (result) {
        this.alertService.showSuccessToast(`${result.changedRows} işlemin maliyeti ve kârı güncellendi.`);
        this.service.refreshIndex.next();
      }
    } finally {
      this.recalculating = false;
    }
  }

  private recalculationSummary(preview: ExchangeRecalculationResult): string {
    const tl = (value: number) => (value ?? 0).toLocaleString("tr-TR", { maximumFractionDigits: 2 });
    const has = (value: number) => (value ?? 0).toLocaleString("tr-TR", { maximumFractionDigits: 3 });
    let html = `<p><b>${preview.changedRows}</b> / ${preview.totalRows} işlemin maliyeti ya da kârı değişecek.</p>`;
    if (preview.convertedLegacyRows > 0)
      html += `<p>${preview.convertedLegacyRows} eski kayıt yeni yönteme geçecek.</p>`;
    html += `<p>Toplam kâr: ${tl(preview.profitBefore?.tl)} → <b>${tl(preview.profitAfter?.tl)}</b> TL, `
      + `${tl(preview.profitBefore?.usd)} → <b>${tl(preview.profitAfter?.usd)}</b> USD, `
      + `${has(preview.profitBefore?.has)} → <b>${has(preview.profitAfter?.has)}</b> HAS</p>`;
    if (preview.unknownValueRows > 0)
      html += `<p class="text-warning">${preview.unknownValueRows} işlemin değeri bilinmiyor; maliyetleri "Birim Maliyeti Ekle" ile girilebilir.</p>`;
    html += `<p>Uygulansın mı?</p>`;
    return html;
  }
}
